module.exports = __webpack_public_path__ + "tickets_closed.7ee72238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/analytics_icons/tickets_closed.png
// module id = 885
// module chunks = 0